<div class="search">
  <app-search-field
    placeholder="Search website or group"
    (searchText)="onSearch($event)"
  ></app-search-field>
</div>

<div class="groups">
  <div class="row">
    <h2>Website groups</h2>
  </div>

  <mat-card appearance="outlined" class="table-container">
    @if (groups$ | async; as groups) {
      <app-table
        [columns]="groupsColumns"
        [dataSource]="groups"
        [totalCount]="totalGroups()"
        (pageChange)="handlePageEvent($event)"
      >
        <ng-container matColumnDef="buttons">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div class="buttons row">
              <button
                matRipple
                class="icon-button"
                matTooltip="Usage details"
                [matTooltipShowDelay]="500"
                matTooltipPosition="above"
                [routerLink]="['/usage/group', element.id]"
                [state]="{ group: element, source: 'list' }"
              >
                <fa-icon [icon]="['fas', 'magnifying-glass-chart']" size="lg"></fa-icon>
              </button>

              <button
                matRipple
                class="icon-button"
                matTooltip="Change disk quota"
                [matTooltipShowDelay]="500"
                matTooltipPosition="above"
              >
                <fa-icon [icon]="['fas', 'pen']" size="lg"></fa-icon>
              </button>
            </div>
          </td>
        </ng-container>
      </app-table>
    }
  </mat-card>
</div>
